export default __webpack_public_path__ + "static/media/target_audience.505e57aa.jpg";